module.exports = __webpack_public_path__ + "img/title-bg.c54f00af.png";